import { AUTH } from '../constants/actionTypes';

const initial = { user: null, capabilities: [], loading: false, error: null };

export default function authReducer(state = initial, action) {
  switch (action.type) {
    case AUTH.LOGIN_REQUEST: return { ...state, loading: true, error: null };
    case AUTH.LOGIN_SUCCESS:
    case AUTH.ME_SUCCESS:    return { ...state, loading: false, user: action.payload, error: null };
    case AUTH.CAPS_SUCCESS:  return { ...state, capabilities: action.payload || [] };
    case AUTH.LOGIN_FAILURE: return { ...state, loading: false, error: action.payload };
    case AUTH.LOGOUT:        return { ...initial };
    default: return state;
  }
}

// Selector helper — co-located so any component can read effective capabilities.
export const hasCap = (state, key) => {
  const { user, capabilities } = state.auth || {};
  if (!user) return false;
  if (user.role === 'admin') return true;
  return (capabilities || []).includes(key);
};
